import React from "react";
import { Button, CircularProgress } from "@material-ui/core";
import useCheckoutClassicStyles from "./checkoutClassicStyles";
import TrustBadge from "./TrustBadge";

// The mobile-only pinned CTA. Presentational; ClassicTemplate owns the state.
export default function MobileStickyBar({
  label,
  onClick,
  disabled,
  busy,
  trust,
  totalLabel,
  totalCaption,
  suppressed,
}) {
  const classes = useCheckoutClassicStyles();

  const barClass = suppressed
    ? `${classes.mobileStickyBar} ${classes.mobileStickyBarHidden}`
    : classes.mobileStickyBar;

  return (
    <div className={barClass}>
      {trust ? (
        <TrustBadge />
      ) : (
        <div className={classes.mobileStickyTotalWrap}>
          <span className={classes.mobileStickyTotal}>{totalLabel}</span>
          {totalCaption ? (
            <span className={classes.mobileStickyCaption}>{totalCaption}</span>
          ) : null}
        </div>
      )}
      <Button
        className={`${classes.mobileProceedButton} ${classes.mobileStickyButton}`}
        variant="contained"
        disableElevation
        onClick={onClick}
        disabled={disabled || busy}
        startIcon={busy ? <CircularProgress size={16} color="inherit" /> : null}
      >
        {label}
      </Button>
    </div>
  );
}
